import { render } from "./IconChevronUpDown.vue?vue&type=template&id=057b754e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronUpDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "057b754e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('057b754e', __exports__)) {
    api.reload('057b754e', __exports__)
  }
  
  module.hot.accept("./IconChevronUpDown.vue?vue&type=template&id=057b754e", () => {
    api.rerender('057b754e', render)
  })

}


export default __exports__